import { InjectionToken } from '@angular/core';

/**
 * Feature flag token used to indicate that GroupTicketsFeatureModule is loaded.
 *
 * Default: false (no GT module → GT UI renders nothing)
 * When GroupTicketsFeatureModule is imported: true (full GT functionality active)
 *
 * @example
 * // In pool-coupon or other shared components
 * readonly gtEnabled = inject(GT_ENABLED_TOKEN, { optional: true }) ?? false;
 */
export const GT_ENABLED_TOKEN = new InjectionToken<boolean>('GT_ENABLED', {
  providedIn: 'root',
  factory: () => false,
});
